$ = require 'jquery'
Auth = require 'app/scripts/db/auth'
ChangeSetPasswordPopoverView = require 'app/scripts/views/member/change-set-password-popover-view'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
WarningBannerView = require 'app/scripts/views/header/warning-banner-view'
templates = require 'app/scripts/views/internal/templates'
{ Analytics, getScreenFromUrl } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ track } = require '@trello/analytics'

module.exports = class SetPasswordBannerView extends WarningBannerView
  initialize: ->
    @listenTo @model, 'change:loginTypes', =>
      @$el.toggle(!Auth.canLogIn())
      $(window).triggerHandler("resize")

    @sendGASEvent = featureFlagClient.get('dataeng.gasv3-event-tracking', false)

  events:
    'click .js-change-password': 'changePassword'

  render: ->

    @$el.html(
      templates.fill(
        require('app/scripts/views/templates/header_warning_password'),
        @model.toJSON()
      )
    )

    if @sendGASEvent
      Analytics.sendViewedBannerEvent
        bannerName: 'setPasswordBanner'
        source: getScreenFromUrl()

    @

  changePassword: (e) ->
    Util.stop(e)
    PopOver.toggle
      elem: @$('.js-change-password')
      view: new ChangeSetPasswordPopoverView({ @model, @modelCache })
    track("Header", "Password Banner", "Open Change Password Menu")
    if @sendGASEvent
      Analytics.sendClickedLinkEvent
        linkName: 'changePasswordLink'
        source: 'setPasswordBanner'

